import styled from "styled-components";

const HomeSpotsContainer = styled.div`
  flex-basis: 50vh;
`;

export default HomeSpotsContainer;
